'use client';

import { useTranslation } from 'react-i18next';

import { LogoIcon } from '@/components/shared/logo-icon';
import { cn } from '@/lib/utils';

type LandingReachBrandPillProps = {
  className?: string;
};

/** White “Reach + logo” capsule used in hero (desktop) and footer (mobile). */
export function LandingReachBrandPill({ className }: LandingReachBrandPillProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-white/80 px-3 py-1.5 shadow-sm dark:border-emerald-900/60 dark:bg-gray-900/70',
        'shrink-0',
        className,
      )}
    >
      <span className="text-sm font-semibold tracking-tight text-gray-900 dark:text-white md:text-base">
        {t('landing.hero.brandName')}
      </span>
      <div className="flex h-6 w-6 items-center justify-center md:h-7 md:w-7">
        <LogoIcon className="h-6 w-6 md:h-7 md:w-7" />
      </div>
    </div>
  );
}
